/*
 * frost-guest-list.js (owner: CONTENT) – <fb-guest-list> („Flocken-Post“ newsletter)
 * - German inline validation (e-mail + required consent) instead of the browser bubbles.
 *   Without JS the native `required` validation still protects the form.
 * - After a post (page reload with #<form id>): focuses the success message or the e-mail field.
 * - One document click handler: any same-page link to the section anchor (default #flocken-post)
 *   scrolls to the form (smooth unless motion is "none"), focuses the e-mail field and pulses the
 *   card once. data-fb-interest="tag" on the link adds that tag to contact[tags].
 * - Snowfall behind the postcard is declarative (.fb-snow[data-fb-snow], mounted by frost-global.js).
 * Never submits anything by itself.
 */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function motion() {
    if (window.FROSTBEULE && typeof window.FROSTBEULE.motion === 'function') return window.FROSTBEULE.motion();
    return document.documentElement.getAttribute('data-motion') || 'full';
  }

  function focusQuietly(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
  }

  if (window.customElements && !window.customElements.get('fb-guest-list')) {
    window.customElements.define(
      'fb-guest-list',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.email = this.querySelector('input[type="email"]');
          this.consent = this.querySelector('input[name="fb_consent"]');
          this.tags = this.querySelector('[data-fb-guest-tags]');
          this.submit = this.querySelector('button[type="submit"]');
          this.errEmail = this.querySelector('[data-fb-guest-error="email"]');
          this.errConsent = this.querySelector('[data-fb-guest-error="consent"]');
          this.success = this.querySelector('[data-fb-guest-success]');

          if (this.form && this.email) {
            this.form.noValidate = true;
            this._onSubmit = this.onSubmit.bind(this);
            this._onEmailInput = this.onEmailInput.bind(this);
            this._onConsentChange = this.onConsentChange.bind(this);
            this.form.addEventListener('submit', this._onSubmit);
            this.email.addEventListener('input', this._onEmailInput);
            if (this.consent) this.consent.addEventListener('change', this._onConsentChange);
          }

          this.afterPost();
        }

        disconnectedCallback() {
          if (this.form && this._onSubmit) this.form.removeEventListener('submit', this._onSubmit);
          if (this.email && this._onEmailInput) this.email.removeEventListener('input', this._onEmailInput);
          if (this.consent && this._onConsentChange) this.consent.removeEventListener('change', this._onConsentChange);
          window.clearTimeout(this._arriveTimer);
        }

        /* Validation -------------------------------------------------------- */
        setError(input, box, message) {
          if (!input || !box) return;
          if (message) {
            box.textContent = message;
            box.hidden = false;
            input.setAttribute('aria-invalid', 'true');
          } else {
            box.textContent = '';
            box.hidden = true;
            input.removeAttribute('aria-invalid');
          }
        }

        emailMessage() {
          var value = (this.email.value || '').trim();
          if (!value) return this.getAttribute('data-msg-email-empty') || '';
          if (!EMAIL_RE.test(value)) return this.getAttribute('data-msg-email-invalid') || '';
          return '';
        }

        onEmailInput() {
          /* only clear while typing; errors appear on submit */
          if (this.email.getAttribute('aria-invalid') === 'true' && !this.emailMessage()) {
            this.setError(this.email, this.errEmail, '');
          }
        }

        onConsentChange() {
          if (this.consent.checked) this.setError(this.consent, this.errConsent, '');
        }

        onSubmit(event) {
          var emailMsg = this.emailMessage();
          var consentMsg = this.consent && !this.consent.checked ? this.getAttribute('data-msg-consent') || '' : '';
          this.setError(this.email, this.errEmail, emailMsg);
          if (this.consent) this.setError(this.consent, this.errConsent, consentMsg);

          if (emailMsg || consentMsg) {
            event.preventDefault();
            focusQuietly(emailMsg ? this.email : this.consent);
            return;
          }
          this.email.value = this.email.value.trim();
          if (this.submit) {
            this.submit.classList.add('is-loading');
            this.submit.setAttribute('aria-busy', 'true');
          }
        }

        /* After the reload that follows a post ------------------------------- */
        afterPost() {
          if (!this.form || !this.form.id) return;
          if (window.location.hash !== '#' + this.form.id) return;
          if (this.success) {
            focusQuietly(this.success);
          } else if (this.errEmail && !this.errEmail.hidden && this.email) {
            focusQuietly(this.email);
          }
        }

        /* Arrival from a link ------------------------------------------------- */
        addInterest(tag) {
          if (!this.tags) return;
          var clean = String(tag)
            .toLowerCase()
            .replace(/[^a-z0-9\-]/g, '')
            .slice(0, 60);
          if (!clean) return;
          var list = (this.tags.value || this.tags.getAttribute('data-base') || '').split(',');
          list = list
            .map(function (t) {
              return t.trim();
            })
            .filter(Boolean);
          if (list.indexOf(clean) === -1) list.push(clean);
          this.tags.value = list.join(',');
        }

        arrive(link) {
          var interest = link && link.getAttribute('data-fb-interest');
          if (interest) this.addInterest(interest);

          var behavior = motion() === 'none' ? 'auto' : 'smooth';
          try {
            this.scrollIntoView({ behavior: behavior, block: 'center' });
          } catch (e) {
            this.scrollIntoView();
          }
          focusQuietly(this.email || this.success);

          this.classList.remove('is-arriving');
          if (motion() !== 'none') {
            void this.offsetWidth;
            this.classList.add('is-arriving');
            var self = this;
            window.clearTimeout(this._arriveTimer);
            this._arriveTimer = window.setTimeout(function () {
              self.classList.remove('is-arriving');
            }, 1400);
          }
        }
      }
    );
  }

  /* One handler for every same-page link to the newsletter anchor. */
  if (!window.__frostGuestLinks) {
    window.__frostGuestLinks = true;
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target && event.target.closest ? event.target.closest('a[href*="#"]') : null;
      if (!link) return;
      var url;
      try {
        url = new URL(link.getAttribute('href'), window.location.href);
      } catch (e) {
        return;
      }
      if (!url.hash || url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      var id;
      try {
        id = decodeURIComponent(url.hash.slice(1));
      } catch (e) {
        return;
      }
      var section = id ? document.getElementById(id) : null;
      if (!section) return;
      var guest = section.tagName === 'FB-GUEST-LIST' ? section : section.querySelector('fb-guest-list');
      if (!guest || typeof guest.arrive !== 'function') return;
      event.preventDefault();
      guest.arrive(link);
    });
  }
})();
